var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconFreehand = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_freehand",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .freehand-class-a {\n        fill: none !important;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_508",
    className: "freehand-class-a",
    "data-name": "Rectangle 508",
    width: 32,
    height: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M81.1,1155.925a2.646,2.646,0,0,0-3.7.975c-.313.6-.645,1.238-.973,1.887L75,1158.112c.332-.65.667-1.3.983-1.9a4.253,4.253,0,0,1,5.961-1.587,4.359,4.359,0,0,1,1.536,6.012l-3.194,5.287c-1.421,2.362-.789,4.962,1.592,6.1a4.087,4.087,0,0,0,4.566-.625,7.093,7.093,0,0,0,2.288-5.525h1.589a8.606,8.606,0,0,1-2.835,6.687,5.726,5.726,0,0,1-6.315.85c-3.341-1.612-4.059-5.275-2.256-8.262l3.194-5.287A2.859,2.859,0,0,0,81.1,1155.925Z",
    transform: "translate(-67 -1148)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconFreehand);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_freehand.23eb3e652ffa2c9374f6be0efebb205b.svg";